import { action, observable } from 'mobx';
import { ModalStore } from 'ui/base/modal';
import { ColorCode as ColorCodeType } from 'services/accounts/types';

export class ShieldIconSelectorStore {
  modal: ModalStore;

  @observable.ref
  value: ColorCodeType;

  @observable.ref
  highlighted: ColorCodeType;

  constructor(avatar: ColorCodeType) {
    this.modal = new ModalStore(false);
    this.value = avatar;
    this.highlighted = avatar;
  }

  reloadHighlighted = action((): void => {
    this.highlighted = this.value;
  });

  commitHighlighted = action((): void => {
    this.value = this.highlighted;
  });

  setHighlighted = action((highlighted: ColorCodeType) => {
    this.highlighted = highlighted;
  });
}